import { BinaryQuestionTemplate, MultipleOptionsTemplate } from '@templates';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '@cycle-hangars/routes/Routes';
import { useCycleStore } from '@cycle-hangars/store/store';
import { ZodError } from 'zod';
import { ErrorMessages } from '@types';
import { scrollTop, parseZodErrors, stringFieldSchema } from '@utils';
import { SELECT_OPTIONS_ERROR } from '@cycle-hangars/constants/errorMessages';

export const CodeMatch = () => {
  const navigate = useNavigate();
  const { doesCodeMatch, updateDoesCodeMatch } = useCycleStore();
  const [result, setResult] = useState(doesCodeMatch);
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const title = 'Does the code on the key match the code on the lock?';

  const handleChange = (option: string) => {
    setResult(option as 'Yes' | 'No');
    setErrorMessages([]);
  };

  const options = [
    {
      labelText: 'Yes',
      isDefault: doesCodeMatch === 'Yes',
    },
    {
      labelText: 'No',
      isDefault: doesCodeMatch === 'No',
    },
  ];

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.CYCLE_HANGAR_SECURE),
  };

  const buttonNext = {
    onClick: () => {
      try {
        const validatedData = stringFieldSchema(
          'doesCodeMatch',
          SELECT_OPTIONS_ERROR.required.message,
        ).parse({
          doesCodeMatch: result,
        });
        if (validatedData.doesCodeMatch) {
          updateDoesCodeMatch(validatedData.doesCodeMatch as 'Yes' | 'No');
        }
        if (result === 'Yes') {
          navigate(RoutesList.KEY_TURN);
        } else if (result === 'No') {
          navigate(RoutesList.LOCK_CODE_DETAILS);
        }
        scrollTop();
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  return (
    <BinaryQuestionTemplate
      title={title}
      options={options}
      errorPath={'doesCodeMatch'}
      errorMessages={errorMessages}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
    />
  );
};
